import { gql } from '@apollo/client'
import { Authentication } from 'share/domain/authentication'

export const TFAUTH_MUTATION = gql`
  mutation SUBMIT_CODE($code: String!, $user: String!, $sessionId: String!) {
    authentication {
      submitMfaCode(code: $code, sessionId: $sessionId, user: $user) {
        idToken
        accessToken
        expirationTime
        requiresMfa
        sessionId
        account {
          id
          givenName
          familyName
          middleName
          suffix
          homePhone
          mobilePhone
          workPhone
          userName
          emailAddress
          street
          zip
          city
          state
          ssn
          caseCount
          accountCreationStep
          contactType
        }
      }
    }
  }
`

export interface IAuth extends Authentication {
  error?: string | undefined
}

export interface TFAuthData {
  authentication: {
    submitMfaCode: IAuth
  }
}

export interface TFAuthVariables {
  code: string
  user: string | null | undefined
  sessionId: string | null
}

export const SIGN_OFF = gql`
  mutation SIGN_OFF {
    authentication {
      signOff
    }
  }
`

export interface SignOffResponse {
  authentication: {
    signOff: boolean
  }
}
